import * as Animate from "react-reveal";
import { ArrowRight } from "../../../components/svgs";

const stories = [
  {
    tag: "LEARNER STORY",
    title: "From curiosity to portfolio evidence.",
    desc:
      "A learner chooses a pathway, completes practical work and becomes ready to present capability with context.",
    cta: "See learner evidence",
    href: "#stories",
    featured: true,
  },
  {
    tag: "HIRING STORY",
    title: "From role brief to focused shortlist.",
    desc:
      "A company clarifies what success looks like and meets people through relevant skills evidence.",
    cta: "Explore UtivaHire",
    href: "#hire",
  },
  {
    tag: "TEAM STORY",
    title: "From one hire to workforce support.",
    desc:
      "A distributed team can connect talent discovery with the operational layer that keeps work moving.",
    cta: "Explore UtivaPay",
    href: "#workforce",
  },
];

const HomeStorySection = () => {
  return (
    <section className="bg-[#f7f9fe] py-16 md:py-24 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <div className="grid home-grid-1208 items-end gap-6 lg:gap-20 mb-10 md:mb-12">
            <div>
              <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-[0.1em] uppercase mb-5">
                <span className="w-8 h-[3px] bg-secondary inline-block"></span>
                Connected outcomes
              </p>
              <h2 className="text-primary font-poppins font-bold tracking-[-0.045em] leading-[1.12] text-3xl md:text-4xl lg:text-6xl">
                Different starting points. One connected platform.
              </h2>
            </div>
            <p className="text-gray text-base font-poppins leading-[1.8]">
              Utiva supports the learner building capability, the company
              finding talent and the team operating across borders.
            </p>
          </div>
        </Animate.Fade>

        <div className="grid home-grid-story-3col gap-3.5">
          {stories.map((story) => (
            <Animate.Fade bottom key={story.tag}>
              <article
                className={`rounded-[21px] min-h-[330px] flex flex-col p-7 ${
                  story.featured
                    ? "bg-primary text-white"
                    : "border border-hire-line bg-white"
                }`}
              >
                <span className="text-secondary font-poppins tracking-[0.09em] text-sm font-extrabold">
                  {story.tag}
                </span>
                <h3
                  className={`mt-auto font-bold font-poppins leading-[1.3] ${
                    story.featured
                      ? "text-white text-[30px]"
                      : "text-primary text-2xl"
                  }`}
                >
                  {story.title}
                </h3>
                <p
                  className={`text-sm font-poppins mt-2 leading-[1.72] ${
                    story.featured ? "text-[#d7dfff]" : "text-gray"
                  }`}
                >
                  {story.desc}
                </p>
                <a
                  href={story.href}
                  className={`mt-2.5 text-sm font-poppins font-bold ${
                    story.featured ? "text-secondary" : "text-primary"
                  }`}
                >
                  {story.cta}{" "}
                  <ArrowRight fill="currentColor" className="inline-block" />
                </a>
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeStorySection;
